(function () {
  'use strict';
  var config = document.querySelector('[data-bioss-accessibility-config]');
  if (!config) return;
  var strings = JSON.parse(config.textContent);
  var lastTrigger = null;
  var wasOpen = false;
  var nextId = 0;

  function buttonify(element) {
    if (element.dataset.biossKeyboard) return;
    element.dataset.biossKeyboard = 'true';
    element.setAttribute('role', 'button');
    element.setAttribute('tabindex', '0');
    element.addEventListener('keydown', function (event) {
      if (event.key === ' ' || (event.key === 'Enter' && element.tagName !== 'A')) {
        event.preventDefault();
        element.click();
      }
    });
  }

  function syncFilters() {
    var panel = document.getElementById('searchspring-slideout_container');
    var open = !!(panel && panel.classList.contains('ss-slideout_show'));
    document.querySelectorAll('.searchspring-slideout_filter').forEach(function (trigger) {
      buttonify(trigger);
      trigger.setAttribute('aria-controls', 'searchspring-slideout_container');
      trigger.setAttribute('aria-expanded', String(open));
      if (!trigger.dataset.biossTrigger) {
        trigger.dataset.biossTrigger = 'true';
        trigger.addEventListener('click', function () { lastTrigger = trigger; });
      }
    });
    document.querySelectorAll('.searchspring-facets h5[ng-click]').forEach(function (heading) {
      buttonify(heading);
      var list = heading.parentElement.querySelector('ul');
      if (list && !list.id) list.id = 'bioss-facet-v409-' + (++nextId);
      if (list) heading.setAttribute('aria-controls', list.id);
      heading.setAttribute('aria-expanded', String(heading.parentElement.classList.contains('menu-open')));
    });
    if (!panel) return;
    panel.setAttribute('role', 'dialog');
    panel.setAttribute('aria-label', strings.filters);
    panel.setAttribute('aria-modal', 'true');
    panel.setAttribute('aria-hidden', String(!open));
    panel.inert = !open;
    var close = panel.querySelector('.searchspring-slideout_button');
    if (close) {
      buttonify(close);
      close.setAttribute('aria-label', strings.close_filters);
    }
    if (open && !wasOpen && close) close.focus();
    if (!open && wasOpen && lastTrigger && lastTrigger.isConnected) lastTrigger.focus();
    wasOpen = open;
  }

  document.addEventListener('keydown', function (event) {
    var panel = document.getElementById('searchspring-slideout_container');
    if (!panel || !panel.classList.contains('ss-slideout_show')) return;
    if (event.key === 'Escape') {
      var close = panel.querySelector('.searchspring-slideout_button');
      if (close) { event.preventDefault(); close.click(); }
    }
    if (event.key !== 'Tab') return;
    var controls = Array.from(panel.querySelectorAll('a[href], button, input, select, [tabindex="0"]')).filter(function (el) {
      return !el.disabled && el.getClientRects().length && getComputedStyle(el).visibility !== 'hidden';
    });
    var first = controls[0];
    var last = controls[controls.length - 1];
    if (event.shiftKey && (document.activeElement === first || !panel.contains(document.activeElement))) {
      event.preventDefault();
      if (last) last.focus();
    } else if (!event.shiftKey && (document.activeElement === last || !panel.contains(document.activeElement))) {
      event.preventDefault();
      if (first) first.focus();
    }
  });

  document.querySelectorAll('.price_qty .price_holder').forEach(function (group) {
    if (group.querySelector('input[type="radio"]')) {
      group.setAttribute('role', 'group');
      group.setAttribute('aria-label', strings.variants);
    }
  });
  syncFilters();
  var pending = false;
  new MutationObserver(function () {
    if (pending) return;
    pending = true;
    requestAnimationFrame(function () { pending = false; syncFilters(); });
  }).observe(document.body, { childList: true, subtree: true, attributes: true, attributeFilter: ['class'] });

  var mobile = window.matchMedia('(max-width: 1023px)');
  var help = document.querySelector('[data-bioss-mobile-help]');
  var ready = false;
  var helpOpened = false;
  function syncHelp() {
    if (!ready) return;
    if (mobile.matches && !helpOpened) window.zE('webWidget', 'hide');
    else window.zE('webWidget', 'show');
  }
  function connectHelp() {
    if (ready || typeof window.zE !== 'function') return;
    ready = true;
    window.zE('webWidget:on', 'close', function () {
      var returnFocus = helpOpened;
      helpOpened = false;
      syncHelp();
      if (returnFocus && mobile.matches && help) help.focus();
    });
    syncHelp();
  }
  if (help) help.addEventListener('click', function (event) {
    connectHelp();
    if (!ready) return;
    event.preventDefault();
    helpOpened = true;
    window.zE('webWidget', 'show');
    window.zE('webWidget', 'open');
  });
  mobile.addEventListener('change', syncHelp);
  document.addEventListener('bioss:zendesk-ready', connectHelp);
  connectHelp();
})();
